module.exports = __webpack_public_path__ + "6b1c31a3c848887f183635ee8655fb77.png";